import { END_CALL } from 'constants/lsqaConstants';
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import endCallIcon from '@lifesize/ux-assets/vectors/svgIcons/end-call.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import classes from '../CallFooter.module.scss';

const EndCallButton = props => (
  <button className={classes.inCallButton} onClick={() => props.onClick()} {...END_CALL} data-testid="end-call-btn">
    <SVG src={endCallIcon} />
    <Tooltip
      location="top"
      style={{ bottom: '100%', marginBottom: 15 }} label={(
        <FormattedMessage id="components.incall.controls.endCall.tooltip" defaultMessage="Leave" />
      )}
    />
  </button>
);

EndCallButton.propTypes = {
  intl: PT.object,
  onClick: PT.func.isRequired,
};

export default EndCallButton;
